import { render } from "./MyCollection.vue?vue&type=template&id=0dc5a4c5&scoped=true&ts=true"
import script from "./MyCollection.vue?vue&type=script&lang=ts"
export * from "./MyCollection.vue?vue&type=script&lang=ts"

import "./MyCollection.vue?vue&type=style&index=0&id=0dc5a4c5&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc5a4c5"]])

export default __exports__